import { render, staticRenderFns } from "./BaseStyle.vue?vue&type=template&id=54db6b6c&scoped=true"
import script from "./BaseStyle.vue?vue&type=script&lang=js"
export * from "./BaseStyle.vue?vue&type=script&lang=js"
import style0 from "./BaseStyle.vue?vue&type=style&index=0&id=54db6b6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54db6b6c",
  null
  
)

export default component.exports